export default __webpack_public_path__ + "a10005eff604c23484d67b3a9f6484f2.png";